export default class Usersnap {
  static open = (userId: string, email: string) => {
    // @ts-expect-error
    window.Usersnap && window.Usersnap.init({ user: { userId, email } });
  };
}
